import React, { useState } from "react";
import DefaultLayout from "../../../layout/vendor/DefaultLayout";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../../../utils/helper";
import { useQuery } from "react-query";
import Footer from "../../../components/Footer";
import { useIDsContext } from "../../../context/IDsContext";

const Teachers = () => {
  const navigate = useNavigate();
  const { data, isLoading, error } = useQuery(["vendors", "/vendors"], () =>
    api.get("/super-admin/vendors").then((res) => {
      console.log("API Response:", res.data); // Log response
      return res.data.data;
    })
  );

  const vendors = data || [];

  // State to store selected vendor ID
  const [selectedVendor, setSelectedVendor] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { setVendorID, setVendorName } = useIDsContext();

  const handleTeacherList = () => {
    if (!selectedVendor) {
      setErrorMessage("Please select a vendor.");
      return;
    }
    setErrorMessage("");
    const selectedVendorData = vendors.find(
      (vendorObj) => vendorObj.vendor._id === selectedVendor
    );
    // const selectedCollegerData = vendors.find(
    //   (college) => college._id === selectedVendor
    // );

    const vendorName = selectedVendorData.vendor.name;

    console.log("vendor._id", selectedVendor);
    setVendorID(selectedVendor);
    console.log("vendor.vendorName:", selectedVendor);
    setVendorName(vendorName);
    navigate("/vendor/teacher-list", {
      state: {
        vendorId: selectedVendor,
        vendorName,
      },
    });
  };

  return (
    <DefaultLayout>
      <Container fluid className="main-container mt-0 mt-md-4 ps-auto ps-md-0">
        <Card className="main-card">
          <Card.Body>
            {/* Title */}
            <div className="d-flex justify-content-center align-items-center h-100">
              <div className="vendor-card">
                <h4 className="text-center mb-4 collhead">Teachers</h4>

                <Card>
                  <Card.Body>
                    {/* Select Vendor */}
                    <Form>
                      <Form.Group controlId="selectVendor" className="mb-4">
                        <Form.Label className="drpvendor">
                          Select Vendor
                        </Form.Label>
                        <Form.Select
                          value={selectedVendor}
                          onChange={(e) => setSelectedVendor(e.target.value)}
                        >
                          <option value="">Select Vendor</option>
                          {vendors.length > 0 ? (
                            vendors.map(
                              ({ vendor }) =>
                                vendor && (
                                  <option key={vendor._id} value={vendor._id}>
                                    {vendor.name}
                                  </option>
                                )
                            )
                          ) : (
                            <option disabled>No vendors available</option>
                          )}
                        </Form.Select>
                        {/* Validation Error Message */}
                        {errorMessage && (
                          <Form.Control.Feedback
                            type="invalid"
                            className="d-block"
                          >
                            {errorMessage}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>

                      {/* Buttons */}
                      <div className="d-flex justify-content-between gap-2">
                        <Button variant="light" className="btn-sec-v">
                          Cancel
                        </Button>
                        <Button
                          className="btn-sec-v"
                          color="#60B1FF"
                          onClick={handleTeacherList}
                        >
                          Continue
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Container>
      <div className="d-none d-lg-block">
        <Footer />
      </div>
    </DefaultLayout>
  );
};

export default Teachers;
